module.exports = __webpack_public_path__ + "static/media/honour.42324d24.svg";